import { FunctionComponent } from "react";
import { useAppSelector } from "./store/hooks";
import { getRankLabel, expForNextLevel } from "./services/FirebaseUsers";

type UserProfilePanelProps = {
  onClose: () => void;
};

const UserProfilePanel: FunctionComponent<UserProfilePanelProps> = ({
  onClose,
}) => {
  const profile = useAppSelector((state) => state.user.profile);

  if (!profile) return null;

  const winRate =
    profile.gamesPlayed > 0
      ? ((profile.wins / profile.gamesPlayed) * 100).toFixed(1)
      : "—";

  const expNeeded = expForNextLevel(profile.level);
  const expPercent = Math.min(100, (profile.experience / expNeeded) * 100);

  const rankLabel = getRankLabel(profile.rating);

  return (
    <div className="Profile-overlay" onClick={onClose}>
      <div className="Profile-modal" onClick={(e) => e.stopPropagation()}>
        <button className="Profile-close" onClick={onClose}>&#x2715;</button>

        <div className="Profile-top">
          <div className="Profile-avatar">
            <span className="Profile-avatar-letter">
              {profile.nickname.charAt(0).toUpperCase()}
            </span>
            <span className="Profile-level-badge">{profile.level}</span>
          </div>
          <div className="Profile-identity">
            <h2 className="Profile-nickname">{profile.nickname}</h2>
            <div className="Profile-rank">{rankLabel}</div>
            <div className="Profile-rating-row">
              <span className="Profile-rating-label">Рейтинг</span>
              <span className="Profile-rating-value">{profile.rating}</span>
            </div>
          </div>
        </div>

        <div className="Profile-level-bar-section">
          <div className="Profile-level-bar-labels">
            <span>Уровень {profile.level}</span>
            <span>{profile.experience} / {expNeeded} XP</span>
          </div>
          <div className="Profile-level-bar">
            <div
              className="Profile-level-bar-fill"
              style={{ width: `${expPercent}%` }}
            />
          </div>
        </div>

        <div className="Profile-coins-row">
          <div className="Profile-coins-icon" />
          <span className="Profile-coins-label">Монеты</span>
          <span className="Profile-coins-value">{profile.coins.toLocaleString()}</span>
        </div>

        <div className="Profile-stats-grid">
          <div className="Profile-stat">
            <div className="Profile-stat-value">{profile.gamesPlayed}</div>
            <div className="Profile-stat-label">Игр</div>
          </div>
          <div className="Profile-stat">
            <div className="Profile-stat-value">{profile.wins}</div>
            <div className="Profile-stat-label">Побед</div>
          </div>
          <div className="Profile-stat">
            <div className="Profile-stat-value">{winRate}%</div>
            <div className="Profile-stat-label">Победы</div>
          </div>
          <div className="Profile-stat">
            <div className="Profile-stat-value">{profile.winStreak}</div>
            <div className="Profile-stat-label">Серия</div>
          </div>
          <div className="Profile-stat">
            <div className="Profile-stat-value">{profile.gammonsWon}</div>
            <div className="Profile-stat-label">Гаммонов</div>
          </div>
          <div className="Profile-stat">
            <div className="Profile-stat-value">{profile.backgammonsWon}</div>
            <div className="Profile-stat-label">Бэкгаммонов</div>
          </div>
          <div className="Profile-stat">
            <div className="Profile-stat-value">{profile.longestWinStreak}</div>
            <div className="Profile-stat-label">Рекорд серии</div>
          </div>
          <div className="Profile-stat">
            <div className="Profile-stat-value">{profile.losses}</div>
            <div className="Profile-stat-label">Поражений</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfilePanel;
